<app-header-hs1 titulo="Local"  (eventSave)="save()" (eventCancel)="voltar()" [deletavel]="deletavel" [editavel]="true" (eventDelete)="delete()"/>

<ion-content [fullscreen]="true">
  <ion-list [inset]="true">
    <form #form="ngForm">
      <ion-item>
        <ion-input name="nome" label-placement="floating" required label="Nome" [(ngModel)]="entidade.nome"
                  >
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-select interface="popover" name="biomas" label-placement="floating" label="Biomas" [(ngModel)]="entidade.biomas"
                    aria-label="Biomas" [compareWith]="compareWith"
                    [multiple]="true">
          <ion-select-option *ngFor="let fu of biomas" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-select interface="popover"  name="tipo" label-placement="floating" label="Tipo" [(ngModel)]="entidade.tipo" aria-label="Tipo">
          <ion-select-option *ngFor="let fu of tipos" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>
    </form>
  </ion-list>
</ion-content>
<app-rodape [exibirBotoes]="false"/>
